import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    required,
    BooleanInput,
    NumberInput,
} from 'react-admin';

const ScheduleCreate = props => (
    <Create {...props}>
        <SimpleForm>
        <ReferenceInput label="Resource" source="resource_id" reference="resources" validate={[required()]}>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput label="Target" source="target_id" reference="targets" validate={[required()]}>
                <SelectInput source="name" />
            </ReferenceInput>
            <BooleanInput source="enabled" />
            <NumberInput source="max_duration" validate={[required()]} />
            <TextInput source="rrule" multiline validate={[required()]} />
        </SimpleForm>
    </Create>
);

export default ScheduleCreate;